import React from 'react';
import "../styles/App.scss";
import "../styles/PagesStyles.scss";
import {Dialog} from '@mui/material';

export default function MyModal(props){
    const{onClose, open, img, description} = props;
    const handleClose=()=>{
        onClose();
    }
    return(
        <Dialog onClose={handleClose} open={open}>
            {/* <DialogTitle>{props.item.name}</DialogTitle> */}
            <img src={img} alt={description}/>
        </Dialog>
    );
}